import { useEffect } from 'react';
import { useApp } from '@/hooks/use-app-context';
import { isTokenExpired } from '@/api/auth.api';
import { sessionRefresher } from '@/api/api-client';
import { isRefreshSession } from '@/api/session-refresh';

export function useTokenGuard() {
  const { user, isAuthenticated, setUser } = useApp();

  useEffect(() => {
    if (!isAuthenticated) return;
    const token = localStorage.getItem('yodi-token');
    if (token && !isTokenExpired(token)) return;
    // A refresh session (spec 008) renews its short token; it ends only if that fails.
    const signOut = () => {
      localStorage.removeItem('yodi-token');
      setUser(null);
    };
    if (token && isRefreshSession()) {
      void sessionRefresher.refresh().then((renewed) => {
        if (renewed === null) signOut();
      });
    } else {
      signOut();
    }
  }, [isAuthenticated, user, setUser]);

  const token = localStorage.getItem('yodi-token');
  const isValid = isAuthenticated && !!token && (!isTokenExpired(token) || isRefreshSession());

  return { isValid };
}
